module.exports = __webpack_public_path__ + "static/media/LogoLastVersion.1fb3ef29.png";